import React, { useRef } from 'react'
import useSize from 'hooks/useSize'
import { scaleLinear } from 'd3-scale'
import { line } from 'd3-shape'

import './styles.scss'

type ChartProps = {
  values: number[]
  flipVertical?: boolean
  isMobile: boolean
}

export const Sparkline: React.FC<ChartProps> = ({
  values,
  flipVertical = false,
  isMobile
}) => {
  if (!values) return null
  const [container, size] = useSize()
  const svg = useRef<SVGSVGElement>(null)

  const markerRad = isMobile ? 1.5 : 2.5
  const padding = 6

  //
  const width = size.width
  const height = 35
  const gutterTop = padding
  const gutterRight = 10
  const gutterLeft = 0
  const gutterBottom = padding
  const plotArea = {
    top: gutterTop,
    right: width - gutterRight,
    left: gutterLeft,
    bottom: height - gutterBottom
  }

  const xAxisScale = React.useMemo(
    () =>
      scaleLinear()
        .domain([0, values.length])
        .range([plotArea.left, plotArea.right]),
    [size]
  )

  const yAxisScale = React.useMemo(
    () =>
      scaleLinear()
        .domain(
          flipVertical
            ? [Math.max(...values), Math.min(...values)]
            : [Math.min(...values), Math.max(...values)]
        )
        .range([plotArea.bottom, plotArea.top]),
    [size]
  )
  const yFunction = d => {
    return yAxisScale(+d)
  }
  const xFunction = (d, i) => xAxisScale(i)
  const lineFunction = React.useMemo(
    () =>
      line()
        .x(xFunction)
        .y(yFunction),
    [size]
  )

  return (
    <svg ref={container} width={width} height={height}>
      <defs>
        <marker
          id='end'
          className='endMarker'
          markerWidth={markerRad * 2}
          markerHeight={markerRad * 2}
          refX={markerRad}
          refY={markerRad}
        >
          <circle cx={markerRad} cy={markerRad} r={markerRad} stroke='none' />
        </marker>
      </defs>
      <path d={lineFunction(values)} markerEnd='url(#end)' />
    </svg>
  )
}
